export default __webpack_public_path__ + "static/media/BrVfMWOHt2XZK8e6NxMRqzrzX3e2.00472fea.jpg";